import { DECADES } from './decades';
import { GENRES } from './genres';

export const ALL = 'All';
export const UNCATEGORIZED = 'Uncategorized';

export const FILTER_LIST = [ALL, ...GENRES, ...DECADES, UNCATEGORIZED];
